export default __webpack_public_path__ + "static/mockup-with-bg-6a0daeb65518d5e47652301ed9754ae5.png";